import { render, staticRenderFns } from "./CheckinTerms.vue?vue&type=template&id=77f39072&"
import script from "./CheckinTerms.vue?vue&type=script&lang=js&"
export * from "./CheckinTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports